var config = require('../config')

module.exports = {
  bind: function () {
    var el = this.el
    this.vm.$once('hook:compiled', function () {
      el.removeAttribute(config.prefix + 'cloak')
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/directives/cloak.js
// module id = 173
// module chunks = 0